import { Document, Page, View, StyleSheet, Text, Image, Font } from "@react-pdf/renderer";
import imgKkp from '../../../assets/images/logo_kkp.jpg'
import srcArial from '../../../assets/custom/font/arial/arial.ttf'
import srcArialBold from '../../../assets/custom/font/arial/ARIBL0.ttf'
import srcRobotoItalic from '../../../assets/custom/font/roboto/Roboto-Italic.ttf';
import ttdImg from "../../../assets/images/ttde.jpg"
// import { useCallback, useEffect, useMemo, useState } from "react";
import { capitalizeFirstLetter, formatDateStringLocalDateINA, getNamaUPTBaru } from "../../../utilities/Utils";
// import KapalService from "../../../services/kapal/KapalService";
// import UserService from "../../../services/user/UserService";
// import PbUmkuService from "../../../services/pbumku/PbumkuService";

Font.register({ family: 'Arial', src: srcArial })
Font.register({ family: 'Arial-Bold', src: srcArialBold })
Font.register({ family: 'Roboto-Italic', src: srcRobotoItalic })
Font.registerHyphenationCallback(word => [word])

const styles = StyleSheet.create({
    page: {
        paddingTop: 20,
        paddingBottom: 48,
        paddingHorizontal: 42,
        boxSizing: "border-box"
    },
    headingImg: {
        width: 115,
        height: 100,
    },
    headingTtd: {
        width: 200,
        height: 60,
    },
    table: {
        display: "table",
        width: "auto"
    },
    tableRow: {
        flexDirection: "row",
        flexWrap: "wrap"
    },
    tableCol: {
        borderWidth: 0,
        borderLeftWidth: 0,
        borderTopWidth: 0,
        padding: 1
    },
    text: {
        fontSize: 10,
        fontFamily: "Arial"
    },
    textBold: {
        fontSize: 12,
        fontFamily: "Arial-Bold"
    },
    watermark: {
        position: 'absolute',
        top: '50%',
        left: '25%',
        fontSize: 80,
        color: 'rgba(150, 150, 150, 0.3)',
        transform: 'rotate(-45deg)',
        zIndex: -1,
    },
    link: {
        fontSize: 10,
        color: 'blue',
        textDecoration: 'underline',
        fontFamily: 'Roboto-Italic'
    },
})

const CetakSptKapal = ({ dataDisposisi, dataPpmKapal, rowData, pegawaiData, uptData }) => {

    return (
        <Document>
            <Page size="A4" style={styles.page} wrap={false}>
                {/* <Text style={styles.watermark}>D R A F T</Text> */}
                <View style={[styles.table, { marginBottom: 3 }]}>
                    <View style={[styles.tableRow, { borderBottom: 2, borderBottomStyle: 'solid' }]}>
                        <View style={[styles.tableCol, { width: '25%' }]}>
                            <Image style={styles.headingImg} src={imgKkp} />
                        </View>
                        <View style={[styles.tableCol, { width: '70%', alignItems: 'center' }]}>
                            <Text style={[styles.textBold, { fontSize: 12, textAlign: 'center', color: '#7895be' }]}>KEMENTERIAN KELAUTAN DAN PERIKANAN</Text>
                            <Text style={[styles.text, { fontSize: 14, textAlign: 'center', color: '#7895be' }]}>BADAN PENGENDALIAN DAN PENGAWASAN MUTU</Text>
                            <Text style={[styles.text, { fontSize: 14, textAlign: 'center', color: '#7895be' }]}>HASIL KELAUTAN DAN PERIKANAN</Text>
                            <Text style={[styles.text, { textAlign: 'center' }]}>JALAN MEDAN MERDEKA TIMUR NO. 16</Text>
                            <Text style={[styles.text, { textAlign: 'center' }]}>JAKARTA 10110, KOTAK POS 4130 JKP 10041</Text>
                            <Text style={[styles.text, { textAlign: 'center' }]}>TELEPON (021) 3519070 (LACAK), FAKSIMILE (021) 3513282</Text>
                            <View style={[styles.tableRow]}>
                                <Text style={[styles.text, { textAlign: 'center' }]}>
                                    LAMAN{' '}
                                </Text>
                                <Text style={styles.link}>
                                    www.kkp.go.id{' '},
                                </Text>
                                <Text style={[styles.text, { textAlign: 'center' }]}>
                                    SUREL{' '}
                                </Text>
                                <Text style={styles.link}>
                                    bppmhkp@kkp.go.id
                                </Text>
                            </View>
                        </View>
                    </View>
                </View>
                <View style={[styles.table, { marginBottom: 5 }]}>
                    <View style={styles.tableRow}>
                        <View style={[styles.tableCol, { width: '100%', alignItems: 'center' }]}>
                            <Text style={[styles.text, { fontSize: 12, textAlign: 'center' }]}>SURAT PERINTAH</Text>
                        </View>
                    </View>
                    <View style={styles.tableRow}>
                        <View style={[styles.tableCol, { width: '100%', alignItems: 'center' }]}>
                            <Text style={[styles.text, { fontSize: 12, textAlign: 'center' }]}>NOMOR {rowData && rowData.nomorSpt}</Text>
                        </View>
                    </View>
                </View>
                <View style={styles.table}>
                    <View style={[styles.tableRow, { marginBottom: 10 }]}>
                        <View style={[styles.tableCol, { width: '20%' }]}>
                            <Text style={[styles.text, { fontSize: 12, textAlign: 'left' }]}>Menimbang</Text>
                        </View>
                        <View style={[styles.tableCol, { width: '3%' }]}>
                            <Text style={[styles.text, { fontSize: 12, textAlign: 'left' }]}>:</Text>
                        </View>
                        <View style={[styles.tableCol, { width: '3%' }]}>
                            <Text style={[styles.text, { fontSize: 12, textAlign: 'left' }]}>1. </Text>
                        </View>
                        <View style={[styles.tableCol, { width: '74%' }]}>
                            <Text style={[styles.text, { fontSize: 12, textAlign: 'left' }]}>Bahwa untuk kelancaran penyelenggaraan Sertifikasi Bidang Perikanan Budi Daya dan Perikanan Tangkap perlu melaksanakan sertifikasi.</Text>
                        </View>
                        <View style={[styles.tableCol, { width: '20%' }]}>
                            <Text style={[styles.text, { fontSize: 12, textAlign: 'left' }]}></Text>
                        </View>
                        <View style={[styles.tableCol, { width: '3%' }]}>
                            <Text style={[styles.text, { fontSize: 12, textAlign: 'left' }]}></Text>
                        </View>
                        <View style={[styles.tableCol, { width: '3%' }]}>
                            <Text style={[styles.text, { fontSize: 12, textAlign: 'left' }]}>2. </Text>
                        </View>
                        <View style={[styles.tableCol, { width: '74%' }]}>
                            <Text style={[styles.text, { fontSize: 12, textAlign: 'left' }]}>Bahwa berdasarkan pertimbangan sebagaimana dimaksud dalam angka satu di atas, Unit Pelaksana Teknis BPPMHKP perlu melakukan inspeksi dan persetujuan rekomendasi penerbitan Sertifikat.</Text>
                        </View>
                    </View>
                </View>
                <View style={[styles.table, { marginBottom: 5 }]}>
                    <View style={styles.tableRow}>
                        <View style={[styles.tableCol, { width: '20%' }]}>
                            <Text style={[styles.text, { fontSize: 12, textAlign: 'left' }]}>Dasar</Text>
                        </View>
                        <View style={[styles.tableCol, { width: '3%' }]}>
                            <Text style={[styles.text, { fontSize: 12, textAlign: 'left' }]}>:</Text>
                        </View>
                        <View style={[styles.tableCol, { width: '3%' }]}>
                            <Text style={[styles.text, { fontSize: 12, textAlign: 'left' }]}>1. </Text>
                        </View>
                        <View style={[styles.tableCol, { width: '74%' }]}>
                            <Text style={[styles.text, { fontSize: 12, textAlign: 'left' }]}>Peraturan Presiden Nomor 193 Tahun 2024 tentang Kementerian Kelautan dan Perikanan.</Text>
                        </View>
                        <View style={[styles.tableCol, { width: '20%' }]}>
                            <Text style={[styles.text, { fontSize: 12, textAlign: 'left' }]}></Text>
                        </View>
                        <View style={[styles.tableCol, { width: '3%' }]}>
                            <Text style={[styles.text, { fontSize: 12, textAlign: 'left' }]}></Text>
                        </View>
                        <View style={[styles.tableCol, { width: '3%' }]}>
                            <Text style={[styles.text, { fontSize: 12, textAlign: 'left' }]}>2. </Text>
                        </View>
                        <View style={[styles.tableCol, { width: '74%' }]}>
                            <Text style={[styles.text, { fontSize: 12, textAlign: 'left' }]}>PP No. 28 Tahun 2025 tentang Penyelenggaraan Perizinan Berusaha Berbasis Risiko.</Text>
                        </View>
                        <View style={[styles.tableCol, { width: '20%' }]}>
                            <Text style={[styles.text, { fontSize: 12, textAlign: 'left' }]}></Text>
                        </View>
                        <View style={[styles.tableCol, { width: '3%' }]}>
                            <Text style={[styles.text, { fontSize: 12, textAlign: 'left' }]}></Text>
                        </View>
                        <View style={[styles.tableCol, { width: '3%' }]}>
                            <Text style={[styles.text, { fontSize: 12, textAlign: 'left' }]}>3. </Text>
                        </View>
                        <View style={[styles.tableCol, { width: '74%' }]}>
                            <Text style={[styles.text, { fontSize: 12, textAlign: 'left' }]}>Permen KP No. 2 tahun 2025 tentang Organisasi dan Tata Kerja Kementerian Kelautan dan Perikanan.</Text>
                        </View>
                        <View style={[styles.tableCol, { width: '20%' }]}>
                            <Text style={[styles.text, { fontSize: 12, textAlign: 'left' }]}></Text>
                        </View>
                        <View style={[styles.tableCol, { width: '3%' }]}>
                            <Text style={[styles.text, { fontSize: 12, textAlign: 'left' }]}></Text>
                        </View>
                        <View style={[styles.tableCol, { width: '3%' }]}>
                            <Text style={[styles.text, { fontSize: 12, textAlign: 'left' }]}>4. </Text>
                        </View>
                        <View style={[styles.tableCol, { width: '74%' }]}>
                            <Text style={[styles.text, { fontSize: 12, textAlign: 'left' }]}>Permen KP No. 10 tahun 2021 tentang Standar Kegiatan Usaha dan Produk pada Penyelenggaraan Perizinan Berusaha Berbasis Risiko Sektor Kelautan dan Perikanan.</Text>
                        </View>
                    </View>
                </View>
                <View style={[styles.table, { marginBottom: 5 }]}>
                    <View style={styles.tableRow}>
                        <View style={[styles.tableCol, { width: '100%', alignItems: 'center' }]}>
                            <Text style={[styles.text, { fontSize: 12, textAlign: 'center' }]}>Memberi Perintah</Text>
                        </View>
                    </View>
                </View>
                <View style={styles.table}>
                    <View style={[styles.tableRow, { marginBottom: 10 }]}>
                        <View style={[styles.tableCol, { width: '20%' }]}>
                            <Text style={[styles.text, { fontSize: 12, textAlign: 'left' }]}>Kepada</Text>
                        </View>
                        <View style={[styles.tableCol, { width: '3%' }]}>
                            <Text style={[styles.text, { fontSize: 12, textAlign: 'left' }]}>:</Text>
                        </View>
                        <View style={[styles.tableCol, { width: '77%' }]}>
                            <Text style={[styles.text, { fontSize: 12, textAlign: 'left' }]}>Kepala {uptData && getNamaUPTBaru(rowData.tanggalSpt, uptData)}.</Text>
                        </View>
                    </View>
                </View>
                <View style={[styles.table, { marginBottom: 10 }]}>
                    <View style={styles.tableRow}>
                        <View style={[styles.tableCol, { width: '20%' }]}>
                            <Text style={[styles.text, { fontSize: 12, textAlign: 'left' }]}>Untuk</Text>
                        </View>
                        <View style={[styles.tableCol, { width: '3%' }]}>
                            <Text style={[styles.text, { fontSize: 12, textAlign: 'left' }]}>:</Text>
                        </View>
                        <View style={[styles.tableCol, { width: '3%' }]}>
                            <Text style={[styles.text, { fontSize: 12, textAlign: 'left' }]}>1. </Text>
                        </View>
                        <View style={[styles.tableCol, { width: '74%' }]}>
                            <Text style={[styles.text, { fontSize: 12, textAlign: 'left' }]}>Menindaklanjuti permohonan {rowData && rowData.namaIzin ? rowData.namaIzin : 'CPIB Kapal'} Nomor Ijin Berusaha : {dataPpmKapal ? dataPpmKapal.nib : ''} a.n {dataPpmKapal ? dataPpmKapal.namaKapal : ''}.</Text>
                        </View>
                        <View style={[styles.tableCol, { width: '20%' }]}>
                            <Text style={[styles.text, { fontSize: 12, textAlign: 'left' }]}></Text>
                        </View>
                        <View style={[styles.tableCol, { width: '3%' }]}>
                            <Text style={[styles.text, { fontSize: 12, textAlign: 'left' }]}></Text>
                        </View>
                        <View style={[styles.tableCol, { width: '3%' }]}>
                            <Text style={[styles.text, { fontSize: 12, textAlign: 'left' }]}>2. </Text>
                        </View>
                        <View style={[styles.tableCol, { width: '74%' }]}>
                            <Text style={[styles.text, { fontSize: 12, textAlign: 'left' }]}>Menugaskan Inspektur Mutu untuk Melaksanakan  Inspeksi {rowData && rowData.namaIzin ? rowData.namaIzin : 'CPIB Kapal'}.</Text>
                        </View>
                        <View style={[styles.tableCol, { width: '20%' }]}>
                            <Text style={[styles.text, { fontSize: 12, textAlign: 'left' }]}></Text>
                        </View>
                        <View style={[styles.tableCol, { width: '3%' }]}>
                            <Text style={[styles.text, { fontSize: 12, textAlign: 'left' }]}></Text>
                        </View>
                        {/* <View style={[styles.tableCol, { width: '3%' }]}>
                            <Text style={[styles.text, { fontSize: 12, textAlign: 'left' }]}>4. </Text>
                        </View>
                        <View style={[styles.tableCol, { width: '74%' }]}>
                            <Text style={[styles.text, { fontSize: 12, textAlign: 'left' }]}>Merekomendasikan Penerbitan {rowData.namaIzin} pada aplikasi OSS</Text>
                        </View> */}
                    </View>
                </View>
                <View style={[styles.table, { marginBottom: 70 }]} >
                    <View style={[styles.tableRow, { marginBottom: 5 }]}>
                        <View style={[styles.tableCol, { width: '60%' }]}>
                            <Text style={[styles.text, { fontSize: 12, textAlign: 'left' }]}></Text>
                        </View>
                        <View style={[styles.tableCol, { width: '40%' }]}>
                            <Text style={[styles.text, { fontSize: 12, textAlign: 'left' }]}>Jakarta, {rowData && formatDateStringLocalDateINA(rowData.tanggalSpt)}</Text>
                        </View>
                    </View>
                    <View style={styles.tableRow}>
                        <View style={[styles.tableCol, { width: '55%' }]}>
                            <Text style={[styles.text, { fontSize: 12, textAlign: 'left' }]}></Text>
                        </View>
                        <View style={[styles.tableCol, { width: '5%' }]}>
                            <Text style={[styles.text, { fontSize: 12, textAlign: 'right' }]}>a.n.</Text>
                        </View>
                        <View style={[styles.tableCol, { width: '40%' }]}>
                            <Text style={[styles.text, { fontSize: 12, textAlign: 'left' }]}>Kepala Badan</Text>
                        </View>
                    </View>
                    <View style={styles.tableRow}>
                        <View style={[styles.tableCol, { width: '60%' }]}>
                            <Text style={[styles.text, { fontSize: 12, textAlign: 'left' }]}></Text>
                        </View>
                        <View style={[styles.tableCol, { width: '40%' }]}>
                            <Text style={[styles.text, { fontSize: 12, textAlign: 'left' }]}>Pengendalian dan Pengawasan Mutu</Text>
                        </View>
                    </View>
                    <View style={styles.tableRow}>
                        <View style={[styles.tableCol, { width: '60%' }]}>
                            <Text style={[styles.text, { fontSize: 12, textAlign: 'left' }]}></Text>
                        </View>
                        <View style={[styles.tableCol, { width: '40%' }]}>
                            <Text style={[styles.text, { fontSize: 12, textAlign: 'left' }]}>Hasil Kelautan dan Perikanan,</Text>
                        </View>
                    </View>
                    <View style={styles.tableRow}>
                        <View style={[styles.tableCol, { width: '60%' }]}>
                            <Text style={[styles.text, { fontSize: 12, textAlign: 'left' }]}></Text>
                        </View>
                        <View style={[styles.tableCol, { width: '40%' }]}>
                            <Text style={[styles.text, { fontSize: 12, textAlign: 'left' }]}>{rowData && capitalizeFirstLetter(rowData.jabtanTtd)},</Text>
                        </View>
                    </View>
                    <View style={[styles.tableRow]}>
                        <View style={[styles.tableCol, { width: '60%' }]}>
                            <Text style={[styles.text, { fontSize: 12, textAlign: 'left' }]}></Text>
                        </View>
                        <View style={[styles.tableCol, { width: '40%' }]}>
                            <Image style={styles.headingTtd} src={ttdImg} />
                        </View>
                    </View>
                    <View style={styles.tableRow}>
                        <View style={[styles.tableCol, { width: '60%' }]}>
                            <Text style={[styles.text, { fontSize: 12, textAlign: 'left' }]}></Text>
                        </View>
                        <View style={[styles.tableCol, { width: '40%' }]}>
                            <Text style={[styles.text, { fontSize: 12, textAlign: 'left' }]}>{pegawaiData && pegawaiData.namaPenandatangan}</Text>
                        </View>
                    </View>
                </View>
                <View style={[styles.table, { marginBottom: 10 }]}>
                    <View style={styles.tableRow}>
                        <View style={[styles.tableCol, { width: '20%' }]}>
                            <Text style={[styles.text, { fontSize: 12, textAlign: 'left' }]}>Tembusan:</Text>
                        </View>
                    </View>
                    <View style={styles.tableRow}>
                        <View style={[styles.tableCol, { width: '100%' }]}>
                            <Text style={[styles.text, { fontSize: 12, textAlign: 'left' }]}>Kepala Badan Pengendalian dan Pengawasan Mutu Hasil Kelautan dan Perikanan</Text>
                        </View>
                    </View>
                </View>
            </Page>
        </Document>
    )
}

export default CetakSptKapal